import { Container } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableCoursePlan from 'modules/pages/lcms/coursePlan/TableCoursePlan';

const CoursePlanPage = () => {
  const { appName } = useAppName();

  return (
    <Container fluid>
      <PageTitle
        title={PAGES[appName]?.lcmsCoursePlan?.title || 'Course Planning'}
        description={
          PAGES[appName]?.lcmsCoursePlan?.description ||
          'Create and manage course planning and schedules. Easily add, edit, or remove course plans to build comprehensive training programs.'
        }
      />
      <TableCoursePlan />
    </Container>
  );
};

export default CoursePlanPage;
